import cn from 'classnames';
import React, { ReactElement } from 'react';
import { HeadingProps } from './Heading.types';

import s from './Heading.module.css';

const Heading = ({
  rank = 2,
  children,
  variant = 'title2',
  weight = 'semibold',
  color = 'neutral-900',
  centerText = false,
  spacing,
  style = {},
  inheritColor = false,
  className,
}: HeadingProps): ReactElement => {
  const Tag = (rank > 6 ? 'h6' : `h${rank}`) as keyof React.JSX.IntrinsicElements;

  return (
    <Tag
      className={cn(s.heading, s[`font-${variant}`], s[weight], className, {
        [s.centerText]: centerText,
        [`spacing-${spacing}`]: !!spacing,
      })}
      style={{
        color: !inheritColor ? `var(--colors-${color})` : undefined,
        ...style,
      }}
    >
      {children}
    </Tag>
  );
};

export default Heading;
